import {MyCardMetaProps, MyCardProps} from "./props";
import {StyledCard, StyledCardMeta} from "./style";
import {ConfigProvider} from "antd";

export const MyCard = (props: MyCardProps) => {
  const {children, ...otherProps} = props
  return (
    <ConfigProvider theme={{
      components: {
        Card: {
          borderRadiusLG: 24
        }
      }
    }}>
      <StyledCard {...otherProps}>
        {children}
      </StyledCard>
    </ConfigProvider>

  )
}

MyCard.Meta = (props: MyCardMetaProps) => {
  return (
    <StyledCardMeta {...props}/>
  )
}

